import {
  Box,
  Portal,
  Grid,
  usePreventWindowScroll,
  useTheme,
} from '@simplywallst/ui-core';

import { AddHoldingsMobile } from '../AddHoldings';
import { EditHoldings } from '../EditHoldings';
import type { ManualPortfolioState } from '../CreateManualPortfolio';

import { usePortfolio } from '@/hooks/portfolio/usePortfolio';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import type { PortfolioToUpdate } from '../../context/ManualPortfolioContext';

import { MobileSafeArea } from './styled';

interface Props {
  initialData?: PortfolioToUpdate;
  portfolioId: Portfolio['id'] | null;
  setPortfolioId: (id: string) => void;
  onClose: () => void;
  manualPortfolioState: ManualPortfolioState;
  setManualPortfolioState: (state: ManualPortfolioState) => void;
}

export const HoldingsModal = ({
  initialData,
  portfolioId,
  onClose,
  manualPortfolioState,
  setManualPortfolioState,
  setPortfolioId,
}: Props) => {
  const theme = useTheme();
  const { data: portfolio } = usePortfolio({
    id: portfolioId ?? '',
  });

  usePreventWindowScroll();
  return (
    <Portal>
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        zIndex="9999"
        backgroundColor="noir"
      >
        <MobileSafeArea>
          <Grid
            templateRows="1fr"
            height={`calc(
                100svh - ${theme.safeAreaInsetTop} - ${theme.safeAreaInsetBottom}
                )`}
          >
            {manualPortfolioState === 'add' ? (
              <AddHoldingsMobile
                portfolio={portfolio}
                onClose={onClose}
                setManualPortfolioState={setManualPortfolioState}
                setPortfolioId={setPortfolioId}
              />
            ) : manualPortfolioState === 'edit' && portfolio ? (
              <EditHoldings
                initialData={initialData}
                onClose={onClose}
                portfolio={portfolio}
                setManualPortfolioState={setManualPortfolioState}
              />
            ) : null}
          </Grid>
        </MobileSafeArea>
      </Box>
    </Portal>
  );
};
